"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var HintButton = function HintButton(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledHintButton, props, "?");
};

var StyledHintButton = _styledComponents["default"].span.withConfig({
  displayName: "HintButton__StyledHintButton",
  componentId: "sc-1anvmhv-0"
})(["font-size:11px;color:", ";border:1px solid ", ";border-radius:50%;outline:none;cursor:pointer;display:inline-flex;justify-content:center;align-items:center;width:16px;height:16px;line-height:16px;", ""], function (props) {
  return props.theme.colors.greyLight;
}, function (props) {
  return props.theme.colors.greyLight;
}, function (props) {
  return props.white && "\n    background-color: ".concat(props.theme.colors.white, ";\n    border-color: ").concat(props.theme.colors.white, ";\n  ");
});

var _default = /*#__PURE__*/_react["default"].memo(HintButton);

exports["default"] = _default;